import React, { useState, useEffect } from "react";
import {
  Text,
  Icon,
  Box,
  Input,
  ButtonGroup,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Textarea,
  HStack,
} from "@chakra-ui/react";

import { MdEdit } from "react-icons/md";
import { returnDateAndTime } from "../../../../utils/Utils.js";
import { downloadAudioFileFromBlob } from "../../../../redux/agent.js";

export default function ChatBox(props) {
  const { selectedTranscript, saveTheUpdatedTranscript, saveQaFeedback } = props;

  const [editIndex, setEditIndex] = useState(null);
  const [editedTranscript, setEditedTranscript] = useState(null);
  const [editButton, setEditButton] = useState(false);
  const [audioVisibility, setAudioVisibility] = useState(false);
  const [showverificationModal, setShowVerificationModal] = useState(false);
  const [audioUrl, setAudioUrl] = useState("");
  const [qaFeedbackText, setQaFeedbackText] = useState("");

  const { isOpen, onOpen, onClose } = useDisclosure();

  const userMessageColor = {
    normal: "#2185d0",
    edit: "#000000",
  };

  // -----------------------------------------------------------------------------------
  // USE EFFECT – LOAD TRANSCRIPT + AUDIO
  // -----------------------------------------------------------------------------------
  useEffect(() => {
    setEditedTranscript(selectedTranscript?.transcript);
    setEditIndex(null);

    if (selectedTranscript?.callRecording) {
      getAudioFromBlob(selectedTranscript);
    }
  }, [selectedTranscript]);

  const triggerOtherAudioDisplay = () => {
    setAudioVisibility(true);
  };

  // -----------------------------------------------------------------------------------
  // CORRECT WORKING getAudioEndpoint()
  // Azure folder structure: "/YYYY/MM/DD/filename"
  // -----------------------------------------------------------------------------------
  const getAudioEndpoint = (data) => {
    const url = data?.callRecording;
    const timestamp = data?.response_time_utc || data?.response_time;

    if (!url || !timestamp) return null;

    const date = new Date(timestamp);

    const formatted =
      "/" +
      date.getFullYear() +
      "/" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "/" +
      String(date.getDate()).padStart(2, "0") +
      "/";

    const parts = url.split("/");
    const fileName = parts[parts.length - 1];

    const finalUrl =
      "https://teckinfostoragejiowest.blob.core.windows.net/teckinfo-call-recordings" +
      formatted +
      fileName;

    console.log("Final Azure Endpoint URL:", finalUrl);

    return finalUrl;
  };

  // -----------------------------------------------------------------------------------
  // DOWNLOAD AUDIO
  // -----------------------------------------------------------------------------------
  const getAudioFromBlob = async (data) => {
    try {
      const endpointUrl = getAudioEndpoint(data);
      if (!endpointUrl) return;

      console.log("Downloading Audio From:", endpointUrl);

      const audioBlobUrl = await downloadAudioFileFromBlob(endpointUrl);

      console.log("Final Audio Blob URL -->", audioBlobUrl);

      setAudioUrl(audioBlobUrl);
    } catch (error) {
      console.error("Error downloading audio:", error);
    }
  };

  const handleInputChange = (event, idx) => {
    const updatedValue = event.target.value;

    setEditedTranscript((prevTranscript) => {
      const updatedTranscript = JSON.parse(JSON.stringify(prevTranscript));
      updatedTranscript[idx].message = [updatedValue];
      return updatedTranscript;
    });
  };

  const getBackgroundColorOfUserMessage = (item, idx) => {
    if (!item.bot && editButton) {
      return userMessageColor.edit;
    } else {
      return userMessageColor.normal;
    }
  };

  const getMessageTextForResponses = (data) => {
    let generatedText = "";
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        generatedText += data[i];
      }
    }
    return generatedText;
  };

  const _onEditFeedback = (text) => {
    setQaFeedbackText(text);
  };

  const saveQaFeedbackText = () => {
    let payload = {
      ...selectedTranscript,
    };
    payload.callAnanlytics.qa_feedback = qaFeedbackText;

    saveQaFeedback(payload);
    setQaFeedbackText("");
  };

  return (
    <>
      <Box>
        {/* -------------------------------- AUDIO PLAYER -------------------------------- */}
        {!!selectedTranscript.callRecording && (
          <figure style={{ margin: "10px auto" }}>
            <audio
              preload="auto"
              src={audioUrl}
              onCanPlayThrough={() => triggerOtherAudioDisplay()}
            ></audio>

            {audioVisibility ? (
              <audio controls style={{ width: "100%" }} src={audioUrl}></audio>
            ) : (
              <audio controls style={{ width: "100%" }} src={null}></audio>
            )}
          </figure>
        )}

        {/* -------------------------------- QA FEEDBACK -------------------------------- */}
        {selectedTranscript.callAnanlytics ? (
          <div
            style={{
              marginTop: "20px",
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "10px",
            }}
          >
            <HStack>
              {selectedTranscript?.callAnanlytics?.qa_feedback ? (
                <Box style={{ width: "50%" }}>
                  <p style={{ fontSize: "18px", marginBottom: "20px" }}>
                    Current Feedback
                  </p>

                  <div style={{ padding: "5px" }}>
                    <p>{selectedTranscript?.callAnanlytics?.qa_feedback}</p>
                  </div>
                </Box>
              ) : (
                <Box style={{ width: "50%" }}>
                  <p style={{ fontSize: "18px", marginBottom: "20px" }}>
                    No Feedback given for this call.
                  </p>
                </Box>
              )}

              <Box style={{ width: "50%" }}>
                <p style={{ fontSize: "18px", marginBottom: "20px" }}>
                  Feedback window
                </p>

                <Textarea
                  onChange={(e) => _onEditFeedback(e.target.value)}
                  value={qaFeedbackText}
                  placeholder="Write feedback"
                />
                <Button
                  style={{ marginTop: "15px", backgroundColor: "#cac7e4" }}
                  onClick={() => {
                    saveQaFeedbackText();
                  }}
                >
                  Submit Feedback
                </Button>
              </Box>
            </HStack>
          </div>
        ) : null}

        {/* -------------------------------- EDIT BUTTON -------------------------------- */}
        {editedTranscript ? (
          <div style={{ float: "right" }}>
            <Button
              onClick={() => {
                if (editButton) {
                  setEditButton(false);
                  setEditedTranscript(selectedTranscript?.transcript);
                } else {
                  setEditButton(true);
                }
              }}
            >
              Edit{" "}
              <Icon
                w="18px"
                h="18px"
                m="0px auto 0px 10px"
                float="right"
                as={MdEdit}
              />
            </Button>
          </div>
        ) : null}

        {/* -------------------------------- CHAT MESSAGES -------------------------------- */}
        <div
          id="scroll-bar-style"
          style={{ height: "60vh", overflow: "auto", marginTop: "4em" }}
        >
          {editedTranscript?.map((item, idx) => (
            <div
              style={{
                width: "100%",
                fontSize: "small",
              }}
              key={idx}
            >
              <div
                style={
                  item.bot
                    ? {
                        float: "left",
                        margin: "10px",
                        padding: "8px",
                        width: "50%",
                        backgroundColor: "#edf0f5",
                        borderRadius: "6px",
                      }
                    : {
                        float: "right",
                        margin: "10px",
                        padding: "8px",
                        width: "50%",
                        backgroundColor: getBackgroundColorOfUserMessage(
                          item,
                          idx
                        ),
                        color: "white",
                        borderRadius: "6px",
                      }
                }
              >
                <Box>
                  {editButton !== true || item.bot ? (
                    <Text>{getMessageTextForResponses(item.message)}</Text>
                  ) : (
                    <Input
                      style={{ color: "white" }}
                      size="sm"
                      variant="unstyled"
                      value={getMessageTextForResponses(item.message)}
                      onChange={(e) => {
                        handleInputChange(e, idx);
                      }}
                    />
                  )}
                </Box>
              </div>

              <div
                style={
                  item.bot
                    ? {
                        float: "left",
                        backgroundColor: "#f4f7fe",
                        borderRadius: "6px",
                        width: "50%",
                        marginLeft: "10px",
                      }
                    : {
                        float: "right",
                        backgroundColor: "#f4f7fe",
                        borderRadius: "6px",
                        width: "50%",
                        marginRight: "15px",
                        textAlign: "right",
                      }
                }
              >
                {returnDateAndTime(item)}
              </div>
            </div>
          ))}
        </div>
      </Box>

      {/* -------------------------------- MODAL -------------------------------- */}
      {!!editButton && (
        <ButtonGroup float="right" marginTop="2em">
          <Button
            onClick={() => {
              setEditedTranscript(selectedTranscript?.transcript);
              setEditButton(!editButton);
            }}
            colorScheme="blackAlpha"
          >
            Reset
          </Button>
          <Button
            onClick={() => {
              setShowVerificationModal(true);
            }}
            colorScheme="blue"
          >
            Save
          </Button>
        </ButtonGroup>
      )}

      <Modal isOpen={showverificationModal} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Message</ModalHeader>

          <ModalBody style={{ height: "40em" }}>
            <p style={{ fontSize: "20px", fontWeight: "bold" }}>
              Edited transcript will be saved
            </p>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                saveTheUpdatedTranscript(editedTranscript);
                setEditButton(!editButton);
                setShowVerificationModal(false);
              }}
            >
              Save
            </Button>

            <Button
              onClick={() => {
                onClose();
                setEditedTranscript(selectedTranscript?.transcript);
                setEditButton(!editButton);
                setShowVerificationModal(false);
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
